const _ = require('lodash')
const npmVersion = require('../package.json').version

const env = _.merge(process.env, typeof (window) === 'undefined' ? {} : window.__env__)

const environment = {
  development: {
    isProduction: false,
    gaTrackingCode: env.GA_TRACKING_CODE ||
      'UA-97183473-4',
    openBrowserAfterBuild: false,
    autoLogin: false,
    debug: true,
    tempUser: {
      accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOjE0OTk4LCJoYXNoIjoiNGE0NjM2YTljMzg5OTdmOGU2YjQxOTljNjE5OWFjZDZhZGRkYWY4MzA5YzM1NGNiMTMyODhjYjU3YTZiZjU0ZSIsImlhdCI6MTQ2Mjg2NzQ4NSwiZXhwIjoxNDYyODg1NDg1fQ.MQRFIvC9Zol8NcpY0jcuUf3C-_k9B_4gu6p34K_rEhM',
      id: 6,
      email: 'dummy@dumm.com',
      firstName: 'Dummy',
      lastName: 'Dumm'
    },
    boInternalUrl: env.BO_INTERNAL_URL ||
      env.BO_URL ||
      'http://localhost:5000',
    boUrl: env.BO_URL || 'http://localhost:5000',
    fileSizeLimit: env.FILE_SIZE_LIMIT || 20971520
  },
  production: {
    isProduction: true,
    gaTrackingCode: env.GA_TRACKING_CODE ||
      'UA-97183473-2',
    boInternalUrl: env.BO_INTERNAL_URL ||
      env.BO_URL ||
      'http://localhost:5001',
    boUrl: env.BO_URL || 'http://localhost:5001',
    fileSizeLimit: env.FILE_SIZE_LIMIT || 20971520
  }
}[env.NODE_ENV || 'development']

export default {
  nodeEnv: env.NODE_ENV || 'development',
  sentry: env.SENTRY,
  productionServer: env.PRODUCTION_SERVER,
  webVersion: npmVersion,
  port: env.PORT || 5001,
  host: env.HOST || 'localhost',
  apiURL: env.API_URL,
  apiv2URL: env.API_V2_URL,
  apiURLfromServer:
    env.API_URL_FROM_SERVER ||
    env.API_URL,
  xFrameEnabled: env.X_FRAME_ENABLED,
  headerColor: env.HEADER_COLOR,
  iosAppLink: 'https://itunes.apple.com/app/orb-participant/id1215719234?mt=8',
  iosLeaderAppLink: 'https://itunes.apple.com/app/id1215719412?mt=8',
  iosAppId: '1215719234',
  androidAppLink: 'https://play.google.com/store/apps/details?id=org.dofe.dofeparticipant',
  androidLeaderAppLink: 'https://play.google.com/store/apps/details?id=org.dofe.dofeleader',
  androidAppId: 'org.dofe.dofeparticipant',
  sessionTtlMinutes: env.SESSION_TTL_MINUTES || 24 * 60,
  publicPath: env.PUBLIC_PATH || '',
  baseUrl: env.BASE_URL || '',
  sessionSecret: env.SESSION_SECRET,
  redisHost: env.REDIS_HOST,
  redisPort: env.REDIS_PORT,
  redisUrl: env.REDIS_URL,
  redisCluster: env.REDIS_CLUSTER,
  gpIframeBaseUrl: env.GP_IFRAME_BASE_URL,
  gpWpUrl: env.GP_WP_URL,
  foClientId: env.CLIENT_ID || 'frontoffice-web',
  foClientSecret: env.CLIENT_SECRET,
  boClientId: env.CLIENT_ID_BO || 'backoffice-web',
  boClientSecret: env.CLIENT_SECRET_BO,
  fileSizeLimit: env.FILE_SIZE_LIMIT || 20971520,
  isCSRFEnabled: env.IS_CSRF_ENABLED || false,
  cspSource: {
    default: env.CSP_SOURCE || '',
    script: env.CSP_SCRIPT_SOURCE || '',
    style: env.CSP_STYLE_SOURCE || '',
    connect: env.CSP_CONNECT_SOURCE || '',
    font: env.CSP_FONT_SOURCE || '',
    img: env.CSP_IMG_SOURCE || ''
  },
  exposeToClient: [
    'API_URL',
    'API_V2_URL',
    'API_URL_FROM_SERVER',
    'BO_URL',
    'BO_INTERNAL_URL',
    'SENTRY',
    'PUBLIC_PATH',
    'BASE_URL',
    'PRODUCTION_SERVER',
    'HEADER_COLOR',
    'GA_TRACKING_CODE',
    'X_FRAME_ENABLED',
    'GP_IFRAME_BASE_URL',
    'GP_WP_URL',
    'IS_CSRF_ENABLED',
    'CSP_SOURCE',
    'CSP_SCRIPT_SOURCE',
    'CSP_STYLE_SOURCE',
    'CSP_CONNECT_SOURCE',
    'CSP_FONT_SOURCE',
    'CSP_IMG_SOURCE'
  ],
  ...environment
}
